'use strict';
require('./vendor');

$(document).ready(function () {
  $('.first').each(function () {
    var el = $(this),
      text = el.html(),
      first = text.slice(0, 1),
      rest = text.slice(1);
    el.html("<span class='firstletter'>" + first + "</span>" + rest);
  });

  // Faq
  $('.faq-question h4, .faq-icon').click(function (e) {
    e.preventDefault();
    $('.faq-extended').stop();
    parent = $(this).closest('.faq-item');
    if (parent.hasClass('active')) {
      parent.find('.faq-extended').slideUp(100);
      parent.removeClass('active');
    } else {
      $('.faq-extended').slideUp(100);
      $('.faq-item').removeClass('active');
      parent.find('.faq-extended').slideDown(100);
      parent.addClass('active');
    }
  });
  //initial load
  $('.faq-extended').slideUp(100);
  $('.faq-item').removeClass('active');

  // Menu
  $('.index').click(function (e) {
    e.preventDefault();
    $('body').toggleClass('menu-open');
  });

  $('.nav-bg').click(function (e) {
    e.preventDefault();
    $('body').toggleClass('menu-open');
  });


});

$(document).foundation();